import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3726f32d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-icon-detail" }
const _hoisted_2 = { class: "product-detail__information" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "product-detail__stock" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "product_description" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descrição", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.formatDecoins(_ctx.product.decoins)), 1),
      (_ctx.checkProductIsActive(_ctx.product))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Produto indisponível"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.checkProductIsActive(_ctx.product))
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass([
            'product-detail',
            _ctx.isProductOutOfStock(_ctx.product) ? 'out-of-stock' : 'in-stock',
          ])
            }, _toDisplayString(_ctx.isProductOutOfStock(_ctx.product) ? "sem" : "em") + " estoque ", 3))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_TUIViewer, {
          "model-value": _ctx.product.description,
          class: "description"
        }, null, 8, ["model-value"])
      ])
    ])
  ]))
}